import { SocialPostWithProductsFragment } from '@graphql/fragments/__generated__/SocialPost.generated'
import { Button, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { Link } from 'react-router-dom'
import { SwiperOptions } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { showPrice } from '../../misc/price'
import { getProductUrl } from '../../urls'

interface PostProductsProps {
  products: SocialPostWithProductsFragment['relatedProducts']
}

const PostProducts: React.FC<PostProductsProps> = ({ products }) => {
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const swiperOptions: SwiperOptions = {
    spaceBetween: 10,
    slidesPerView: 1,
    watchSlidesProgress: true,
    loop: false,
    allowSlideNext: products.length > 1,
    allowSlidePrev: products.length > 1,
    speed: smDown ? 200 : 0,
    autoHeight: true,
    allowTouchMove: smDown,
    pagination: {
      clickable: true,
      el: `#swiper-pagination-post-products`,
    },
    navigation: {
      prevEl: `#swiper-button-prev-post-products`,
      nextEl: `#swiper-button-next-post-products`,
    },
  }
  return (
    <div className='relative'>
      {products.length > 0 && (
        <>
          <Swiper {...swiperOptions}>
            {products.map(node => {
              const isPriceRange = node.priceRange.discount.min !== node.priceRange.discount.max
              const spec = node.specifics[0]
              if (!spec) return null
              return (
                <SwiperSlide key={node.id}>
                  <div className='bg-white px-10 md:px-30 py-10 md:py-0 shadow-lg md:shadow-none m-10 md:m-0 flex md:flex-col flex-row'>
                    <Link to={getProductUrl(spec.slug, spec.pk)} className='no-underline w-2/6 md:w-auto mr-10 md:mr-0'>
                      <img
                        src={node.thumbnailUrl}
                        alt={spec.name}
                        className='object-contain object-center w-full h-auto md:h-200'
                      />
                    </Link>
                    <div className='flex-1'>
                      <div className='text-gray text-base text-center py-10'>
                        <Link to={getProductUrl(spec.slug, spec.pk)} className='no-underline line-clamp-2'>
                          {spec.shortName || spec.name}
                        </Link>
                      </div>
                      <div className='text-gray text-base flex items-center flex-wrap justify-center text-center mb-15'>
                        <span>
                          {showPrice({
                            currency: node.priceRange.currency,
                            amount: node.priceRange.discount.min,
                          })}
                        </span>
                        {isPriceRange && (
                          <>
                            <span> - </span>
                            <span>
                              {showPrice({
                                currency: node.priceRange.currency,
                                amount: node.priceRange.discount.max,
                              })}
                            </span>
                          </>
                        )}
                      </div>
                      <div>
                        <Button
                          component={Link}
                          to={getProductUrl(spec.slug, spec.pk)}
                          variant='contained'
                          color='primary'
                          size='large'
                          disableElevation
                          fullWidth
                        >
                          <span className='md:py-5 text-base md:text-lg'>Buy Now</span>
                        </Button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
          <div
            id={`swiper-pagination-post-products`}
            className={`swiper-pagination swiper-pagination-clickable swiper-pagination-bullets w-full ${
              products.length > 1 ? 'block' : 'hidden'
            } md:hidden`}
          />
          <div
            id={`swiper-button-prev-post-products`}
            className='swiper-button-prev swiper-button--small hidden md:block'
            style={{ top: 113 }}
          />
          <div
            id={`swiper-button-next-post-products`}
            className='swiper-button-next swiper-button--small hidden md:block'
            style={{ top: 113 }}
          />
        </>
      )}
    </div>
  )
}

export default PostProducts
